module.exports = __webpack_public_path__ + "img/about.ab4df179.png";